var styleDataHash = 'ec05ca56';  
export const injectCss = (() => {
  var css = `.j1Y-I{height:100%;overflow:hidden;width:100%}[dir] .j1Y-I{border:0}._16xOD{height:100%;max-width:100%;position:relative;width:100%}.FoQUz{bottom:0;position:absolute;top:0}[dir] .FoQUz{background:rgba(51,51,51,.05)}[dir=ltr] .FoQUz,[dir=rtl] .FoQUz{left:0;right:0}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});





